import type { TO_KeyValueData } from '@stratumn/studio-shared';

//? selectedVariable is set in the component on spawn using the selectedVariableRef from the block datInfo
export const initialTOKeyValueData: Omit<TO_KeyValueData, 'selectedVariable'> =
  {
    title: 'Default Key Value Title',
    viewType: 'KeyValue'
  };
